import { render } from "./CommonAgreementTips.vue?vue&type=template&id=476eb93e&scoped=true"
import script from "./CommonAgreementTips.vue?vue&type=script&lang=js"
export * from "./CommonAgreementTips.vue?vue&type=script&lang=js"

import "./CommonAgreementTips.vue?vue&type=style&index=0&id=476eb93e&scoped=true&lang=css"

import exportComponent from "D:\\Project\\Carryglobal\\GlobalLinkVIPNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476eb93e"]])

export default __exports__